import styled from 'styled-components';

export default styled.div`
    color: #b0b0b0;
`;